@if (open && alert) {
<aside class="adr-drawer" [class.adr-drawer--resizing]="resizing" [style.width.px]="width">
    <div class="adr-drawer-resize" (mousedown)="startResize($event)" title="Drag to resize"></div>
    <app-alert-detail-drawer
        [alert]="alert"
        [mute]="mute"
        [index]="nav.index"
        [total]="nav.total"
        [showActions]="true"
        [showOpenInAlerts]="openInAlerts"
        (closed)="drawer.close()"
        (navigated)="drawer.navigate($event)"
        (refreshed)="onRefreshed()"
    ></app-alert-detail-drawer>
</aside>
}
